import styles from './EmailFieldWithSuggestionList.module.scss';

const SUGGESTED_DOMAINS = ['@gmail.com', '@yahoo.com', '@hotmail.com', '@aol.com', '@outlook.com'];

type EmailFieldWithSuggestionListProps = {
  input?: string;
  onSelect: (value: string) => void;
};

const EmailFieldWithSuggestionList = ({ input = '', onSelect }: EmailFieldWithSuggestionListProps) => {
  if (!input.length || input.includes('@')) {
    return null;
  }

  return (
    <div className={styles.listContainer}>
      <div className={styles.list}>
        {SUGGESTED_DOMAINS.map((domain) => (
          <div key={domain} className={styles.listItem} onClick={() => onSelect(input + domain)}>
            {input + domain}
          </div>
        ))}
      </div>
    </div>
  );
};

export default EmailFieldWithSuggestionList;
